import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { TravelTwoIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'

import useEnrollment from '../../../../lib/hooks/use-enrollment'
import ClientSpacePageTitle from '../client-space-page-title'
import HostFamilyCard from './client-enrollment-host-family-card'
import ClientFrenchManagerCard from './client-french-manager-card'

const ClientHostFamilyContactWithoutTransport = () => {
  const { enrollment } = useEnrollment()

  return (
    <div className="flex flex-col gap-4">
      <ClientSpacePageTitle
        icon={<TravelTwoIcon color={tailwindColors.primary.dark.DEFAULT} />}
        title="RDV lieu de séjour"
      />
      {enrollment.mainProposition?.journey.date.product.noTransportGuide && (
        <InnerBox className="rounded-lg py-3 px-4 bg-white-hover">
          <div
            dangerouslySetInnerHTML={{
              __html: enrollment.mainProposition?.journey.date.product.noTransportGuide
            }}
          />
        </InnerBox>
      )}
      {/* <ClientEnrollmentTripInformationWarningCard /> */}
      <HostFamilyCard enrollmentId={enrollment.id} />
      <ClientFrenchManagerCard
        enrollmentId={enrollment.id}
        center={enrollment.enrollmentCenter?.center}
      />
    </div>
  )
}

export default ClientHostFamilyContactWithoutTransport
